declare global {
  interface Window {
    webExperiment?: {
      getVariants: () => Record<string, { key: string }>;
    };
  }
}

export const experimentUtils = {
  isExperimentEnabledForTesting: (experimentKey: string, variantName?: string): boolean => {
    if (!window?.location.search) return false;
    const searchParams = new URLSearchParams(window.location.search);
    const experimentKeyParamValue = searchParams.get(experimentKey);
    if (experimentKeyParamValue) {
      return experimentKeyParamValue === (variantName || 'treatment');
    }
    return false;
  },
  isExperimentEnabled: (experimentKey: string, variantName?: string): boolean => {
    if (!window?.webExperiment) {
      return false;
    }

    const variants = window.webExperiment.getVariants();
    const variant = variants[experimentKey];
    if (!variant) {
      return false;
    }
    return variant.key === (variantName || 'treatment');
  },
};
